(function () {
  if (window.__quickAddSizesLoaded) return;
  window.__quickAddSizesLoaded = true;

  // Set the form's variant id from the clicked size button, then dispatch ATC.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-size-add-to-cart]');
    if (!btn || btn.disabled) return;

    // Block click if user was dragging the size slider
    var slider = btn.closest('.quick-add__sizes');
    if (slider && slider.dataset.wasDragging) return;

    e.preventDefault();

    var form = btn.form || btn.closest('form');
    if (form && btn.dataset.variantId) {
      var idInput = form.querySelector('[data-quick-add-variant-input]') || form.querySelector('input[name="id"]');
      if (idInput) idInput.value = btn.dataset.variantId;
    }

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', { detail: { button: btn } })
    );
  });

  // Drag-to-scroll for size sliders on desktop
  var dragState = null;

  document.addEventListener('mousedown', function (e) {
    var slider = e.target.closest('.quick-add__sizes');
    if (!slider) return;
    dragState = {
      slider: slider,
      startX: e.pageX,
      scrollLeft: slider.scrollLeft,
      moved: false,
    };
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragState) return;
    var dx = e.pageX - dragState.startX;
    if (Math.abs(dx) > 3) dragState.moved = true;
    dragState.slider.scrollLeft = dragState.scrollLeft - dx;
  });

  document.addEventListener('mouseup', function () {
    if (!dragState) return;
    dragState.slider.style.cursor = '';
    dragState.slider.style.userSelect = '';
    if (dragState.moved) {
      dragState.slider.dataset.wasDragging = '1';
      setTimeout(function () {
        delete dragState.slider.dataset.wasDragging;
      }, 100);
    }
    dragState = null;
  });
})();
